import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StateType } from 'src/redux/reducers';
import {
  REQUEST_GET_MOS_STATUS,
  REQUEST_MOS_RESYNC_PLAYLIST,
  REQUEST_TOGGLE_MOS_AUTO_FETCH,
} from 'src/redux/reducers/mos';

export function useMosActions(playlistId?: string | null) {
  const dispatch = useDispatch();

  const { data: playlists } = useSelector((state: StateType) => state.playlist.getAll);
  const mosId = useSelector((state: StateType) => state.rundown.detail.data?.externalReference);
  const { connected, autoFetch, statusLoading } = useSelector((state: StateType) => state.mos);

  const mosPlaylist = playlistId
    ? playlists?.find((p) => p.id === playlistId && p.externalReference)
    : playlists?.find((p) => p.externalReference);

  const roId = mosPlaylist?.externalReference;

  const handleToggleAutoFetch = useCallback(() => {
    if (!mosId) return;
    dispatch({
      type: REQUEST_TOGGLE_MOS_AUTO_FETCH,
      payload: { mosId, roId, enabled: !autoFetch },
    });
  }, [dispatch, mosId, roId, autoFetch]);

  const handlePullMos = useCallback(() => {
    if (!mosId) return;
    dispatch({
      type: REQUEST_MOS_RESYNC_PLAYLIST,
      payload: { mosId, roId },
    });
  }, [dispatch, mosId, roId]);

  // Fetch MOS status on mount
  useEffect(() => {
    if (!mosId) return;
    dispatch({ type: REQUEST_GET_MOS_STATUS, payload: { mosId } });
  }, [dispatch, mosId]);

  return {
    mosId,
    connected,
    autoFetch,
    statusLoading,
    mosPlaylist,
    handleToggleAutoFetch,
    handlePullMos,
  };
}
